var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
import * as React from 'react';
import * as queryString from 'query-string';
import { withRouter } from '../../../common/utils/with-router';
import { toMenuItem } from '../gc-section-data';
var HeaderAccountMenuLanguagesComponent = /** @class */function (_super) {
  __extends(HeaderAccountMenuLanguagesComponent, _super);
  // `withRouter` requires constructor to be called
  // eslint-disable-next-line no-useless-constructor
  function HeaderAccountMenuLanguagesComponent(props) {
    return _super.call(this, props) || this;
  }
  HeaderAccountMenuLanguagesComponent.prototype._url = function (langId) {
    var location = this.props.location;
    var query = Object.assign(queryString.parse(location.search), {
      langid: langId
    });
    return "".concat(location.pathname, "?").concat(queryString.stringify(query));
  };
  HeaderAccountMenuLanguagesComponent.prototype.render = function () {
    var _this = this;
    var _a = this.props,
      _b = _a.locales,
      locales = _b === void 0 ? [] : _b,
      _c = _a.separator,
      separator = _c === void 0 ? true : _c;
    var localesMap = locales.filter(function (locale) {
      return locale;
    }).map(function (_a) {
      var locale = _a.locale,
        displayLanguage = _a.displayLanguage,
        langId = _a.langId;
      return locale && toMenuItem({
        id: locale,
        className: 'uitk-list-item',
        label: displayLanguage ? displayLanguage.charAt(0).toLocaleUpperCase(locale === null || locale === void 0 ? void 0 : locale.replace('_', '-')) + displayLanguage.slice(1) : '',
        href: _this._url(langId),
        rel: 'nofollow',
        attributes: {
          role: 'menuitem',
          tabindex: 0
        }
      });
    });
    return React.createElement(React.Fragment, null, locales.length > 0 && separator && React.createElement("hr", null), React.createElement("div", null, localesMap));
  };
  return HeaderAccountMenuLanguagesComponent;
}(React.Component);
export var HeaderAccountMenuLanguages = withRouter(HeaderAccountMenuLanguagesComponent);